export interface DeviceCondition_Interface {
  id:number,
  takhir:number,
  tajil:number,
  day:number,
  brabar:number,
  username:string,
  persianDate:string,
}

export function Empty_DeviceCondition_Interface():DeviceCondition_Interface{
  return{
    id:0,
    takhir:0,
    tajil:0,
    day:0,
    brabar:0,
    username:'',
    persianDate:'',
  }
}
